import ArrowBack from "@mui/icons-material/ArrowBack";
import BusinessIcon from "@mui/icons-material/Business";
import HomeIcon from "@mui/icons-material/Home";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Paper,
  Radio,
  styled,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginFooter } from "../../components/shared/Login/LoginFooter";

interface Props {
  onProceed: (type: any) => void;
}

export default function AccountTypeCard({ onProceed }: Props) {
  const [selected, setSelected] = useState<string>("");
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate("/login");
  };
  return (
    <Box
      sx={{
        width: "100%",
        height: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        mt: 8,
      }}>
      <Container maxWidth="md" sx={{ width: { xs: "580px", md: "830px" }, mb: 10 }}>
        <Paper
          elevation={3}
          sx={{
            position: "relative",
            borderRadius: 3,
            mb: 4,
            px: { xs: 2, md: 4 },
            py: { xs: 2, md: 2 },
          }}>
          <>
            <Box sx={{ position: "absolute", left: 20, top: 20 }}>
              <IconButton size="small" onClick={handleGoBack}>
                <ArrowBack fontSize="small" sx={{ color: "black" }} />
              </IconButton>
            </Box>
            <Typography variant="h6" fontWeight={600} gutterBottom textAlign={"center"}>
              Choose Your Account Type
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom textAlign={"center"}>
              Select the type of account you'd like to Sign up
            </Typography>

            <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }} mt={2}>
              <Grid item xs={4} sm={4} md={6}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 5,
                    borderRadius: 2,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderColor: selected === "residential" ? "#007bff" : "divider",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelected("residential");
                  }}>
                  <Radio
                    checked={selected === "residential"}
                    sx={{
                      position: "absolute",
                      top: 8,
                      left: 8,
                      m: 0,
                      p: 0,
                      "& .MuiSvgIcon-root": {
                        fontSize: 19,
                      },
                      "&.Mui-checked .MuiSvgIcon-root": {
                        fontSize: 19,
                      },
                    }}
                  />
                  <HomeIcon sx={{ fontSize: 40, color: "green", mb: 1, mt: 2 }} />
                  <Typography variant="subtitle1" fontWeight={500}>
                    Residential
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={4} sm={4} md={6}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 5,
                    borderRadius: 2,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderColor: selected === "business" ? "#007bff" : "divider",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelected("business")}>
                  <Radio
                    checked={selected === "business"}
                    sx={{
                      position: "absolute",
                      top: 8,
                      left: 8,
                      m: 0,
                      p: 0,
                      "& .MuiSvgIcon-root": {
                        fontSize: 19,
                      },
                      "&.Mui-checked .MuiSvgIcon-root": {
                        fontSize: 19,
                      },
                    }}
                  />
                  <BusinessIcon sx={{ fontSize: 40, color: "green", mb: 1, mt: 2 }} />
                  <Typography variant="subtitle1" fontWeight={500}>
                    Business
                  </Typography>
                </Paper>
              </Grid>
            </Grid>

            <Box mt={2} textAlign="center">
              <StyledProceedButton
                variant="outlined"
                disabled={!selected}
                onClick={() => onProceed(selected)}>
                PROCEED
              </StyledProceedButton>
            </Box>
          </>
        </Paper>
        <LoginFooter />
      </Container>
    </Box>
  );
}
const StyledProceedButton = styled(Button)(({ disabled, theme }) => ({
  borderRadius: 20,
  padding: "8px 20px",
  fontWeight: 600,
  color: disabled ? theme.palette.text.disabled : "#fff",
  backgroundColor: disabled ? "transparent" : "#026CE3",
  borderColor: disabled ? "rgba(0, 0, 0, 0.23)" : "#026CE3",
  "&:hover": {
    backgroundColor: disabled ? "transparent" : "#025AC1",
  },
}));
